module.exports = __webpack_public_path__ + "img/amigos_-18_gay.077c0e14.webp";